// extracted by mini-css-extract-plugin
export default {"gettingStartedWholeBox":"Applications_gettingStartedWholeBox__J4c79","fadeInAnimation":"Applications_fadeInAnimation__gRGQl","hideBox":"Applications_hideBox__cp7AK"};